import { useCallback, useEffect } from 'react';
import { CandidateStatus, useUpdateCandidateStatus } from '~/domain/PermanentJobs';
import { IToggleControls } from '~/hooks/useToggle';
import {
  RejectCandidateConfirmationPopup,
  RejectCandidateSuccessPopup,
} from '../../RejectCandidatePopups';

interface IProps {
  controls: IToggleControls;
  candidateId: string;
  professionalName: string;
}

export const RejectPopupConfirmation = ({ controls, candidateId, professionalName }: IProps) => {
  const { isError, isPending, isSuccess, mutate, reset } = useUpdateCandidateStatus();

  const handleConfirmRejectCandidate = () =>
    mutate({ candidateIds: [candidateId], status: CandidateStatus.Rejected });

  const handleClosePopup = useCallback(() => {
    reset();
    controls.setOff();
  }, [controls, reset]);

  useEffect(() => {
    if (isError) {
      handleClosePopup();
    }
  }, [handleClosePopup, isError]);

  return (
    <>
      {!isSuccess ? (
        <RejectCandidateConfirmationPopup
          isLoading={isPending}
          professionalName={professionalName}
          onClose={handleClosePopup}
          onConfirm={handleConfirmRejectCandidate}
        />
      ) : (
        <RejectCandidateSuccessPopup
          professionalName={professionalName}
          onClose={handleClosePopup}
        />
      )}
    </>
  );
};
